<script setup lang="ts">
import type { PageHeaderProps } from './types'

defineProps<PageHeaderProps>()
</script>

<template>
  <header
    class="ui-page-header flex items-center justify-between gap-lg font-sans max-[40rem]:items-stretch max-[40rem]:flex-col"
  >
    <div class="ui-page-header__copy grid min-w-0 gap-2xs">
      <div class="ui-page-header__title-row flex items-center gap-2xs">
        <slot name="icon" />
        <h1
          class="ui-page-header__title m-0 text-[length:var(--ui-page-title-size)] font-[var(--ui-page-title-weight)] leading-[var(--ui-page-title-line-height)] text-[color:var(--ui-page-title-color)]"
        >
          {{ title }}
        </h1>
      </div>
      <p
        v-if="subtitle"
        class="ui-page-header__subtitle m-0 text-[length:var(--ui-page-description-size)] leading-[var(--ui-page-description-line-height)] text-[color:var(--ui-page-description-color)]"
      >
        {{ subtitle }}
      </p>
    </div>
    <div v-if="$slots.actions" class="ui-page-header__actions flex items-center gap-xs">
      <slot name="actions" />
    </div>
  </header>
</template>
